import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { headers, url } from "../../utils/const";
import PosNavigation from "../lotery/pos-navigation";

const money = (value) =>
  Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const emptyPlayer = () => ({
  name: "",
  document: { type: "cedula", number: "" },
  phone: "",
  email: "",
  point: localStorage.getItem("point"),
  register: localStorage.getItem("user"),
});

const Player = () => {
  const [amountRetiro, setAmountRetiro] = useState();
  const [playerToPay, setPlayerToPay] = useState();
  const [disabled, setDisabled] = useState(false);
  const [credit, setCredit] = useState({ amount: "", player: {} });
  const [show, setShow] = useState(false);
  const [showRetiro, setShowRetiro] = useState(false);
  const [showCredit, setShowCredit] = useState(false);
  const [listPlayer, setListPlayer] = useState([]);
  const [playerAddCredit, setPlayerAddCredit] = useState();
  const [filter, setFilter] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [player, setPlayer] = useState(emptyPlayer);

  useEffect(() => {
    if (localStorage.getItem("level") !== "4") {
      window.location.href = "/";
    }
  }, []);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const response = await fetch(`${url}/player/data`, {
          method: "get",
          headers,
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data?.message || "No se pudieron cargar los jugadores");
        if (active) setListPlayer(Array.isArray(data?.player) ? data.player : []);
      } catch (cause) {
        if (active) setError(cause?.message || "No se pudieron cargar los jugadores");
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  const handleClose = () => setShow(false);
  const handleCloseCredit = () => setShowCredit(false);
  const handleCloseRetiro = () => setShowRetiro(false);

  const handleShowRetiro = (element) => {
    const pending = element.credit?.retiro?.find((ret) => ret.paid === false);
    setAmountRetiro(pending?.amount || 0);
    setPlayerToPay(element);
    setDisabled(false);
    setShowRetiro(true);
  };

  const handleShowCredit = (element) => {
    setPlayerAddCredit(element);
    setCredit({ player: element, amount: "" });
    setDisabled(false);
    setShowCredit(true);
  };

  const CreatePlayer = async () => {
    const response = await fetch(`${url}/player`, {
      method: "post",
      headers,
      body: JSON.stringify(player),
    });
    const data = await response.json();
    if (data?.player) {
      setListPlayer(Array.isArray(data.player) ? data.player : listPlayer);
      window.alert(data.msg);
      setPlayer(emptyPlayer());
      handleClose();
    }
  };

  const AddCredit = async () => {
    setDisabled(true);
    const response = await fetch(`${url}/player/add-credit`, {
      method: "post",
      headers,
      body: JSON.stringify(credit),
    });
    const data = await response.json();
    window.alert(data.msg);
    handleCloseCredit();
    window.location.reload();
  };

  const PayCredit = async () => {
    setDisabled(true);
    const response = await fetch(`${url}/player/retiro-credito`, {
      method: "post",
      headers,
      body: JSON.stringify({ player: playerToPay, amount: amountRetiro }),
    });
    const data = await response.json();
    window.alert(data.msg);
    handleCloseRetiro();
    window.location.reload();
  };

  const normalizedFilter = filter.trim().toLowerCase();
  const filteredPlayers = listPlayer.filter((item) =>
    String(item?.name || "").toLowerCase().includes(normalizedFilter) ||
    String(item?.phone || "").toLowerCase().includes(normalizedFilter)
  );

  return (
    <div className="queen-pos-page">
      <div className="queen-pos reina-section-shell">
        <PosNavigation active="player" />

        <main className="reina-section-main noPrint">
          <section className="reina-panel">
            <div className="reina-page-heading">
              <div>
                <span className="reina-eyebrow">Administración</span>
                <h2>Control de jugadores</h2>
                <p>Consulta balances, acredita fondos y procesa retiros pendientes desde el punto de venta.</p>
              </div>
              <div className="reina-action-buttons">
                <button type="button" className="reina-btn reina-btn-gold" onClick={() => setShow(true)}>
                  Registrar jugador
                </button>
              </div>
            </div>

            <div className="reina-page-heading">
              <div>
                <span className="reina-badge">{filteredPlayers.length} jugador{filteredPlayers.length === 1 ? "" : "es"}</span>
              </div>
              <input
                type="search"
                className="reina-search"
                placeholder="Buscar por nombre o celular"
                value={filter}
                onChange={(event) => setFilter(event.target.value)}
                aria-label="Buscar jugadores"
              />
            </div>

            {error && <div className="reina-status is-error" role="alert">{error}</div>}
            {loading && <div className="reina-status" role="status">Cargando jugadores...</div>}

            {!loading && !error && (
              <div className="reina-table-wrap">
                <table className="table reina-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Nombre</th>
                      <th>Teléfono</th>
                      <th>Crédito</th>
                      <th>Estado</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredPlayers.length > 0 ? (
                      filteredPlayers.map((item, index) => {
                        const hasPendingWithdrawal = Boolean(item.credit?.retiro?.some((ret) => ret.paid === false));
                        return (
                          <tr key={item._id || item.document?.number || `${item.name}-${index}`}>
                            <td>{index + 1}</td>
                            <td><strong>{item.name || "—"}</strong></td>
                            <td>{item.phone || "—"}</td>
                            <td>RD$ {money(item.credit?.balance)}</td>
                            <td>
                              <span className={`reina-badge ${item.activated ? "is-active" : "is-inactive"}`}>
                                {item.activated ? "Activo" : "Desactivado"}
                              </span>
                            </td>
                            <td>
                              <div className="reina-table-actions">
                                <button type="button" className="reina-btn reina-btn-success" onClick={() => handleShowCredit(item)}>
                                  Agregar crédito
                                </button>
                                {hasPendingWithdrawal && (
                                  <button type="button" className="reina-btn reina-btn-gold" onClick={() => handleShowRetiro(item)}>
                                    Pagar retiro
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="6" className="reina-empty">No se encontraron jugadores.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </section>
        </main>

        <Modal show={show} onHide={handleClose} size="lg" className="reina-modal" centered>
          <Modal.Header closeButton>
            <Modal.Title>Registrar nuevo jugador</Modal.Title>
          </Modal.Header>
          <form onSubmit={(event) => event.preventDefault()}>
            <Modal.Body>
              <div className="row g-3">
                <div className="col-md-6">
                  <label htmlFor="player-document-type">Tipo de documento</label>
                  <select
                    id="player-document-type"
                    className="form-select"
                    value={player.document.type}
                    onChange={(event) => setPlayer({ ...player, document: { ...player.document, type: event.target.value } })}
                  >
                    <option value="cedula">Cédula</option>
                    <option value="pasaporte">Pasaporte</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label htmlFor="player-document-number">Número de documento</label>
                  <input
                    id="player-document-number"
                    type="text"
                    className="form-control"
                    value={player.document.number}
                    onChange={(event) => setPlayer({ ...player, document: { ...player.document, number: event.target.value } })}
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="player-name">Nombre del jugador</label>
                  <input id="player-name" type="text" className="form-control" value={player.name} onChange={(event) => setPlayer({ ...player, name: event.target.value })} />
                </div>
                <div className="col-md-6">
                  <label htmlFor="player-phone">Teléfono celular</label>
                  <input id="player-phone" type="tel" className="form-control" value={player.phone} onChange={(event) => setPlayer({ ...player, phone: event.target.value })} />
                </div>
                <div className="col-12">
                  <label htmlFor="player-email">Correo electrónico</label>
                  <input id="player-email" type="email" className="form-control" value={player.email} onChange={(event) => setPlayer({ ...player, email: event.target.value })} />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button type="button" className="reina-btn reina-btn-muted" onClick={handleClose}>Cerrar</button>
              <button type="button" className="reina-btn reina-btn-primary" onClick={CreatePlayer}>Guardar jugador</button>
            </Modal.Footer>
          </form>
        </Modal>

        <Modal show={showCredit} onHide={handleCloseCredit} size="sm" className="reina-modal" centered>
          <Modal.Header closeButton>
            <Modal.Title>Agregar crédito</Modal.Title>
          </Modal.Header>
          <form onSubmit={(event) => event.preventDefault()}>
            <Modal.Body>
              <p><strong>{playerAddCredit?.name || ""}</strong><br />{playerAddCredit?.phone || ""}</p>
              <label htmlFor="player-credit">Monto (RD$)</label>
              <input
                id="player-credit"
                type="number"
                min="0"
                step="0.01"
                className="form-control"
                value={credit.amount}
                onChange={(event) => setCredit({ player: playerAddCredit, amount: event.target.value })}
              />
            </Modal.Body>
            <Modal.Footer>
              <button type="button" className="reina-btn reina-btn-muted" onClick={handleCloseCredit}>Cerrar</button>
              <button type="button" className="reina-btn reina-btn-success" onClick={AddCredit} disabled={disabled}>Agregar</button>
            </Modal.Footer>
          </form>
        </Modal>

        <Modal show={showRetiro} onHide={handleCloseRetiro} size="sm" className="reina-modal" centered>
          <Modal.Header closeButton>
            <Modal.Title>Retiro de crédito</Modal.Title>
          </Modal.Header>
          <form onSubmit={(event) => event.preventDefault()}>
            <Modal.Body>
              <p><strong>{playerToPay?.name || ""}</strong></p>
              <p>Documento: {playerToPay?.document?.number || "—"}</p>
              <p>Monto pendiente: <strong>RD$ {money(amountRetiro)}</strong></p>
            </Modal.Body>
            <Modal.Footer>
              <button type="button" className="reina-btn reina-btn-muted" onClick={handleCloseRetiro}>Cerrar</button>
              <button type="button" className="reina-btn reina-btn-gold" onClick={PayCredit} disabled={disabled}>Pagar retiro</button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    </div>
  );
};

export default Player;
